import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "rideFilled"
const RideFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M9.749 13.5C10.785 13.5 11.624 14.34 11.624 15.375S10.784 17.25 9.749 17.25 7.874 16.41 7.874 15.375 8.714 13.501 9.749 13.5M17.624 13.5C18.66 13.5 19.499 14.34 19.499 15.375S18.659 17.25 17.624 17.25 15.749 16.41 15.749 15.375 16.589 13.501 17.624 13.5M14.132 7.688C15.076 7.688 15.983 8.063 16.652 8.73L18.645 10.727 21.985 11.336C22.608 11.449 23.061 11.992 23.061 12.626V13.204L23.04 13.28 22.446 15.36C22.286 15.924 21.77 16.312 21.184 16.313H20.074C20.186 16.02 20.25 15.706 20.25 15.375Q20.249 15.24 20.236 15.106 20.21 14.842 20.132 14.595C19.927 13.937 19.472 13.39 18.876 13.066Q18.651 12.946 18.406 12.868 18.033 12.751 17.623 12.75 17.488 12.75 17.356 12.764 17.09 12.79 16.844 12.868C16.628 12.935 16.426 13.031 16.238 13.148 15.495 13.612 15 14.435 15 15.375Q14.999 15.503 15.012 15.628 15.02 15.706 15.033 15.782 15.04 15.825 15.047 15.867 15.092 16.097 15.175 16.312H12.199C12.311 16.023 12.374 15.707 12.374 15.376Q12.374 15.24 12.361 15.106 12.334 14.842 12.257 14.595C12.052 13.937 11.597 13.39 11 13.066Q10.776 12.946 10.531 12.868 10.158 12.751 9.748 12.75 9.614 12.75 9.48 12.764 9.215 12.79 8.97 12.868C8.753 12.935 8.55 13.031 8.363 13.148 7.62 13.612 7.124 14.435 7.124 15.375Q7.124 15.503 7.137 15.628 7.145 15.706 7.158 15.782 7.164 15.825 7.172 15.867 7.217 16.097 7.3 16.312H5.98C5.054 16.313 4.42 15.375 4.764 14.513L5.655 12.284Q5.676 12.236 5.7 12.188H6.75C7.06 12.188 7.313 11.935 7.313 11.625S7.06 11.063 6.75 11.063H6.343L7.093 8.813H6.75C6.439 8.812 6.187 8.56 6.187 8.25S6.439 7.688 6.749 7.688zM3.75 14.25C3.75 15.078 3.078 15.75 2.25 15.75H1.125V14.25zM5.25 10.875C5.25 11.703 4.578 12.375 3.75 12.375H1.125V10.875zM13.8 10.07C14.04 10.454 14.463 10.687 14.915 10.687H17.017L15.855 9.528C15.398 9.07 14.779 8.812 14.132 8.812H13.014zM5.25 7.5C5.25 8.328 4.578 9 3.75 9H1.5V7.5z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default RideFilledIcon
